<template>
  <div class="menu-container">
    <a-menu
      mode="inline"
      :selectedKeys="active_menu_key"
      :items="menu_items"
      @click="handle_menu_click"
    >
    </a-menu>
  </div>
</template>
<script setup lang="ts">
import { useMenuStore } from '@/stores/menu'
import { computed } from 'vue'
import type { MenuEvent } from './menu'
import router from '@/router'

const menu_store = useMenuStore()
const active_menu_key = computed(() => [menu_store.activeMenu?.key || ''])
const menu_items = computed(() =>
  menu_store.menuItems.filter(menu =>
    menu.condition ? menu.condition() : true
  )
)
function handle_menu_click(event: MenuEvent) {
  console.log('isCollapsed: ', menu_store.is_collapsed)
  if (event.item.path) {
    router.push(event.item.path)
  }
}
</script>
<style scoped>
.menu-container {
  padding: 10px;
}
.is-active,
.is-active:hover {
  color: var(--color-text-active);
  background-color: var(--color-primary);
}

.menu-icon {
  width: 40px;
  height: 24px;
  display: inline-flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  transition: padding-right 300ms;
}
</style>
